/* Tidify jar size calculator.
   Flow: style -> food -> package size -> the jar, with quantity and a bundle offer.
   Data lives in size-calculator-data.js */
(function () {
  var root = document.querySelector('[data-sizecalc]');
  var D = window.TIDIFY_SIZE_DATA;
  if (!root || !D) return;

  var stylesEl = root.querySelector('[data-styles]');
  var foodsEl = root.querySelector('[data-foods]');
  var packsEl = root.querySelector('[data-packs]');
  var foodStep = root.querySelector('[data-foodstep]');
  var packStep = root.querySelector('[data-packstep]');
  var resultEl = root.querySelector('[data-result]');

  var ORDER = [
    'Square, bamboo lid',
    'Round, bamboo lid',
    'Round, acacia screw lid',
    'Round, acacia lid',
    'Round, Vianna acacia lid'
  ];

  var chosenStyle = null;   // null = any style
  var chosenFood = null;

  function money(n) { return '$' + n.toFixed(2); }
  function esc(s) { return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function img(f) { return D.base + f; }

  /* style -> [{oz, o, b}] , smallest first */
  var byStyle = {};
  D.sizes.forEach(function (s) {
    s.o.forEach(function (o) {
      (byStyle[o.s] = byStyle[o.s] || []).push({ oz: s.oz, o: o, b: s.b });
    });
  });
  var styleNames = ORDER.filter(function (n) { return byStyle[n]; });

  function thumbFor(name) {
    var list = byStyle[name];
    return list[Math.floor(list.length / 2)].o.im;
  }
  function rangeFor(name) {
    var list = byStyle[name];
    return list[0].oz + '–' + list[list.length - 1].oz + ' oz';
  }

  function clearOn(container) {
    Array.prototype.forEach.call(container.children, function (c) { c.classList.remove('is-on'); });
  }

  /* ---------- step 1: style ---------- */
  function styleCard(name) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sizecalc__style';
    if (name) {
      b.innerHTML =
        '<span class="sizecalc__styleimg"><img src="' + img(thumbFor(name)) + '" alt="" loading="lazy" width="300" height="300"></span>' +
        '<span class="sizecalc__stylename">' + esc(name) + '</span>' +
        '<span class="sizecalc__stylerange">' + rangeFor(name) + '</span>';
    } else {
      b.className += ' sizecalc__style--any';
      b.innerHTML =
        '<span class="sizecalc__stylename">Show me anything</span>' +
        '<span class="sizecalc__stylerange">Every style, best price first</span>';
    }
    b.addEventListener('click', function () {
      clearOn(stylesEl);
      b.classList.add('is-on');
      chosenStyle = name;
      foodStep.hidden = false;
      packStep.hidden = true;
      resultEl.hidden = true;
      if (chosenFood) {
        packStep.hidden = false;
        clearOn(packsEl);
      }
    });
    return b;
  }

  stylesEl.appendChild(styleCard(null));
  styleNames.forEach(function (n) { stylesEl.appendChild(styleCard(n)); });

  /* ---------- steps 2 and 3 ---------- */
  function chip(text, onClick) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sizecalc__chip';
    b.textContent = text;
    b.addEventListener('click', function () {
      clearOn(b.parentNode);
      b.classList.add('is-on');
      onClick();
    });
    return b;
  }

  D.foods.forEach(function (f) {
    foodsEl.appendChild(chip(f.n, function () {
      chosenFood = f;
      packsEl.innerHTML = '';
      resultEl.hidden = true;
      f.p.forEach(function (p) { packsEl.appendChild(chip(p.l, function () { solve(f, p); })); });
      packStep.hidden = false;
    }));
  });

  /* ---------- the maths ---------- */
  function fit(list, oz) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].oz * D.tol >= oz) return { entry: list[i], qty: 1 };
    }
    for (var n = 2; n <= 4; n++) {
      for (var j = 0; j < list.length; j++) {
        if (list[j].oz * n * D.tol >= oz) return { entry: list[j], qty: n };
      }
    }
    return null;
  }

  function solve(food, pack) {
    var oz = (pack.g / food.d) / 29.5735 * D.head;

    if (chosenStyle) {
      var inStyle = fit(byStyle[chosenStyle], oz);
      if (inStyle) {
        render(food, pack, oz, inStyle.entry.oz, [inStyle.entry.o], inStyle.entry.b, inStyle.qty, null);
        return;
      }
      // nothing in the chosen style goes that big — say so and show what does
      var anyBig = fitAcross(oz);
      render(food, pack, oz, anyBig.oz, anyBig.opts, anyBig.b, anyBig.qty,
        'Our ' + chosenStyle.toLowerCase() + ' range stops at ' +
        byStyle[chosenStyle][byStyle[chosenStyle].length - 1].oz + ' oz, so here is what does fit.');
        return;
    }

    var any = fitAcross(oz);
    render(food, pack, oz, any.oz, any.opts, any.b, any.qty, null);
  }

  function fitAcross(oz) {
    for (var i = 0; i < D.sizes.length; i++) {
      if (D.sizes[i].oz * D.tol >= oz) {
        return { oz: D.sizes[i].oz, opts: D.sizes[i].o, b: D.sizes[i].b, qty: 1 };
      }
    }
    var best = null;
    for (var n = 2; n <= 4; n++) {
      for (var j = 0; j < D.sizes.length; j++) {
        if (D.sizes[j].oz * n * D.tol >= oz) {
          var cost = D.sizes[j].o[0].pr * n;
          if (!best || cost < best.cost) best = { oz: D.sizes[j].oz, opts: D.sizes[j].o, b: D.sizes[j].b, qty: n, cost: cost };
          break;
        }
      }
    }
    return best || { oz: null, opts: [], b: null, qty: 0 };
  }

  /* ---------- cart ---------- */
  function refreshBubble(res) {
    try {
      if (!res || !res.sections || !res.sections['cart-icon-bubble']) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = res.sections['cart-icon-bubble'];
      var fresh = tmp.querySelector('#shopify-section-cart-icon-bubble');
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && fresh) bubble.innerHTML = fresh.innerHTML;
    } catch (err) {}
  }

  function addToCart(btn, id, qty) {
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(qty) }], sections: 'cart-icon-bubble' })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error('add failed');
        btn.textContent = qty > 1 ? 'Added ' + qty + ' to cart' : 'Added to cart';
        var done = resultEl.querySelector('[data-done]');
        if (done) done.hidden = false;
        refreshBubble(res);
        setTimeout(function () { btn.disabled = false; btn.textContent = original; }, 2600);
      })
      .catch(function () { btn.disabled = false; btn.textContent = 'Try again'; });
  }

  /* ---------- render ---------- */
  function render(food, pack, oz, sizeOz, opts, bundle, qty, warning) {
    resultEl.hidden = false;

    if (!sizeOz || !opts.length) {
      resultEl.innerHTML = '<div class="sizecalc__card"><p>That is more than four of our largest jars. Send us a message and we will work something out.</p></div>';
      return;
    }

    var many = qty > 1;
    var html = '<div class="sizecalc__answer">' +
      '<div class="sizecalc__reason">' + esc(pack.l) + ' of ' + esc(food.n.toLowerCase()) +
        ' fills about <strong>' + Math.round(oz) + ' fl oz</strong></div>' +
      '<div class="sizecalc__pick">' + (many ? qty + ' &times; ' : '') + sizeOz + ' oz</div>';

    if (warning) {
      html += '<div class="sizecalc__warn">' + esc(warning) + '</div>';
    } else {
      html += '<div class="sizecalc__hint">' +
        (opts.length > 1 ? 'Available in ' + opts.length + ' styles.' : '') +
        ' Need more than one? Change the number before you add.</div>';
    }
    html += '</div>';

    html += '<div class="sizecalc__opts">';
    opts.forEach(function (o, idx) {
      html += '<div class="sizecalc__opt">' +
        '<div class="sizecalc__optimg"><img src="' + img(o.im) + '" alt="' + esc(o.s) + ', ' + sizeOz + ' oz" loading="lazy" width="300" height="300"></div>' +
        '<div class="sizecalc__optbody">' +
          '<div class="sizecalc__optname">' + sizeOz + ' oz &middot; ' + esc(o.s) + '</div>' +
          '<div class="sizecalc__optprice">' + money(o.pr) + ' each</div>' +
          '<div class="sizecalc__qty">' +
            '<button type="button" class="sizecalc__qtybtn" data-step="-1" data-i="' + idx + '" aria-label="Fewer">&minus;</button>' +
            '<input class="sizecalc__qtyval" data-qty="' + idx + '" type="number" inputmode="numeric" min="1" max="24" value="' + qty + '">' +
            '<button type="button" class="sizecalc__qtybtn" data-step="1" data-i="' + idx + '" aria-label="More">+</button>' +
          '</div>' +
          '<button type="button" class="button button--primary sizecalc__add" data-id="' + o.id + '" data-i="' + idx + '">Add to cart</button>' +
        '</div>' +
      '</div>';
    });
    html += '</div>';

    if (bundle) {
      var save = bundle.was - bundle.pr;
      html += '<div class="sizecalc__bundle">' +
        '<div class="sizecalc__optimg sizecalc__optimg--sm"><img src="' + img(bundle.im) + '" alt="Set of ' + bundle.q + ', ' + sizeOz + ' oz" loading="lazy" width="300" height="300"></div>' +
        '<div class="sizecalc__bundlebody">' +
          '<div class="sizecalc__bundlelabel">Filling more than one shelf?</div>' +
          '<div class="sizecalc__bundlename">Set of ' + bundle.q + ' &times; ' + sizeOz + ' oz</div>' +
          '<div class="sizecalc__bundleprice">' + money(bundle.pr) +
            ' <s>' + money(bundle.was) + '</s> <em>save ' + money(save) + '</em></div>' +
        '</div>' +
        '<button type="button" class="button sizecalc__add sizecalc__addbundle" data-id="' + bundle.id + '" data-fixed="1">Add the set</button>' +
      '</div>';
    }

    html += '<div class="sizecalc__done" data-done hidden>Added. <a href="/cart">View cart</a></div>';
    resultEl.innerHTML = html;

    resultEl.querySelectorAll('.sizecalc__qtybtn').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = resultEl.querySelector('[data-qty="' + b.dataset.i + '"]');
        input.value = Math.max(1, Math.min(24, (parseInt(input.value, 10) || 1) + Number(b.dataset.step)));
      });
    });

    resultEl.querySelectorAll('.sizecalc__add').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.dataset.fixed) { addToCart(b, b.dataset.id, 1); return; }
        var input = resultEl.querySelector('[data-qty="' + b.dataset.i + '"]');
        addToCart(b, b.dataset.id, Math.max(1, Math.min(24, parseInt(input.value, 10) || 1)));
      });
    });
  }
})();
